import { SvgIcon } from '@mui/material';

export const IconSearch = () => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24">
    <path d="M21.7315 20.6919L20.692 21.7314L15.3055 16.4079C14.0092 17.4612 12.3562 18.0928 10.5556 18.0928C6.39309 18.0928 3.01855 14.7182 3.01855 10.5553C3.01855 6.39285 6.39309 3.01831 10.5556 3.01831C14.7185 3.01831 18.093 6.39285 18.093 10.5553C18.093 12.3559 17.4614 14.009 16.4081 15.3052L21.7315 20.6919ZM10.5558 16.5333C13.8574 16.5333 16.5337 13.8571 16.5337 10.5554C16.5337 7.25414 13.8574 4.5779 10.5558 4.5779C7.25448 4.5779 4.57824 7.25414 4.57824 10.5554C4.57824 13.8571 7.25448 16.5333 10.5558 16.5333Z" />
  </SvgIcon>
);
